"use client";

import React from "react";

/**
 * Dinamik JSON-LD oluşturur ve bir `<script>` etiketi olarak döner.
 * @param {string} id - script etiketi için benzersiz bir id
 * @param {Object} jsonLd - JSON-LD için dinamik parametreler
 * @returns {React.Component|null} React bileşeni veya null
 */
export const JsonLdScript = ({ id, jsonLd }) => {
  // Kontroller: id ve jsonLd gerekli
  if (!id || !jsonLd) {
    console.warn('JsonLdScript: id ve jsonLd parametreleri gerekli');
    return null;
  }

  // jsonLd boş obje veya null ise
  if (typeof jsonLd !== 'object' || Object.keys(jsonLd).length === 0) {
    console.warn('JsonLdScript: jsonLd boş veya geçersiz');
    return null;
  }

  // JSON stringify hatası kontrolü
  try {
    const jsonString = JSON.stringify(jsonLd);
    
    // JSON string boş ise
    if (!jsonString || jsonString === '{}') {
      console.warn('JsonLdScript: JSON string boş');
      return null;
    }

    return (
      <script
        id={id}
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: jsonString,
        }}
      />
    );
  } catch (error) {
    console.error('JsonLdScript: JSON stringify hatası:', error);
    return null;
  }
};
